import { useAtomValue } from "jotai";

import { selectedCustomerAtom } from "~/shared/state/user-profile-state.ts";

import { useGetCurrentUserInfo } from "./use-current-user-info.ts";
import { useDeploymentType } from "./use-deployment-type.ts";

/**
 * Returns whether the current external user should be treated as a vendor.
 * Default everyone to being a Vendor when not sure
 */
export const useIsVendor = () => {
	const { isInternal } = useDeploymentType();
	const selectedCustomer = useAtomValue(selectedCustomerAtom);
	const {
		data: currentUser,
		isLoading,
		isError,
	} = useGetCurrentUserInfo(isInternal);

	// `useGetCurrentUserInfo` is gated on a customer being available for
	// external users — when disabled it reports `isLoading: false` even
	// though we don't yet have an answer. Treat "external + no customer"
	// as still loading so downstream gates don't think the role is known.
	const isWaitingForCustomer = !isInternal && selectedCustomer?.id == null;

	const role = currentUser?.role?.toLowerCase();
	const isResolvedNonVendor =
		!isInternal &&
		!isLoading &&
		!isError &&
		!isWaitingForCustomer &&
		typeof role === "string" &&
		role.length > 0 &&
		role !== "vendor";

	const isVendor = !isInternal && !isResolvedNonVendor;

	return {
		isVendor,
		isLoading: isLoading || isWaitingForCustomer,
		isError,
	};
};
